import { apiClient, type ApiResponse } from "./apiClient";

/**
 * Payload from `GET /global/config` used for module chrome (display name).
 * Other tenant limits may be present but are unused here.
 */
export type ModuleGlobalConfig = {
  module_id?: number;
  module_name?: string;
  /** User-facing module label (page title, breadcrumbs, document title). */
  module_display_name?: string | null;
};

export type ModuleGlobalConfigResponse = ApiResponse<ModuleGlobalConfig>;

/** GET /global/config — module display name and related tenant chrome. */
export async function fetchModuleGlobalConfig(): Promise<ModuleGlobalConfigResponse> {
  return apiClient.get<ModuleGlobalConfig>("/global/config");
}
